import React, { useState, useMemo } from 'react';
import { SearchIcon, CheckIcon } from '@/components/Icons';

interface NeighborhoodMultiSelectProps {
  options: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

export const NeighborhoodMultiSelect: React.FC<NeighborhoodMultiSelectProps> = ({ options, selected, onChange }) => {
  const [search, setSearch] = useState('');

  const filteredOptions = useMemo(() => {
    return options.filter(opt => opt.toLowerCase().includes(search.toLowerCase()));
  }, [options, search]);

  const toggleOption = (opt: string) => {
    const next = selected.includes(opt) 
      ? selected.filter(s => s !== opt) 
      : [...selected, opt];
    onChange(next);
  };

  return (
    <div className="space-y-2">
      <div className="relative">
        <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar barrio..."
          className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
        />
      </div>
      
      <div className="max-h-48 overflow-y-auto border border-gray-100 rounded-lg p-1 bg-gray-50/50">
        {filteredOptions.length === 0 ? (
          <p className="text-xs text-gray-500 p-3 text-center">No se encontraron barrios</p>
        ) : (
          filteredOptions.map(opt => {
            const isSelected = selected.includes(opt);
            return (
              <button
                key={opt}
                onClick={() => toggleOption(opt)}
                className={`w-full flex items-center justify-between px-3 py-2 text-sm rounded-md transition-colors ${
                  isSelected ? 'bg-sky-100 text-sky-700 font-medium' : 'hover:bg-white text-gray-600'
                }`}
              >
                <span className="truncate">{opt}</span>
                {isSelected && <CheckIcon className="w-4 h-4" />}
              </button>
            );
          })
        )}
      </div>
      
      {selected.length > 0 && (
        <div className="flex items-center justify-between pt-1">
          <span className="text-xs text-gray-500">{selected.length} seleccionados</span>
          <button 
            onClick={() => onChange([])}
            className="text-xs text-sky-600 hover:underline font-medium"
          >
            Limpiar
          </button>
        </div>
      )}
    </div>
  );
};
